import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltLeft, faSearch } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux';

import * as actions from '../../../store/actions/index';
import classes from './EmployeesTable.module.css';

import Spinner from '../../UI/Spinner/Spinner';
import EmployeePersonCard from '../EmployeePersonCard/EmployeePersonCard';
import EmployeesTableListItem from './EmployeesTableListItem/EmployeesTableListItem'
import CustomModal from '../../UI/Modal/Modal';
import {ClearButton} from "react-bootstrap-typeahead";
import {checkCyrillicLetters} from "../../../services/generalService";
import {Affix} from "antd";
import {cloneDeep} from "lodash";
import { LuExpand } from "react-icons/lu";

const isForMobile = window.innerWidth < 801;

class EmployeesTable extends Component {
    state = {
        selectedEmployee: null,
        searchEmployee: this.props.searchMatch,
        modalShow: false,
        employees: []
    }

    componentDidMount() {
        this.props.onGetDepartmentEmployees(this.props.selectedDepartmentId)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.departmentEmployees !== this.props.departmentEmployees) {
            if (!isForMobile && this.props.searchMatch !== '') this.filterEmployees(this.props.searchMatch)
            else if (isForMobile && this.state.searchEmployee) this.filterEmployees(this.state.searchEmployee)
            else {
                this.setState(state => {
                    return {...state, employees: [...this.sortEmployeesForFIOAndChief(this.props.departmentEmployees)]}
                })
            }
        }
        if (this.props.selectedDepartmentId && prevProps.selectedDepartmentId !== this.props.selectedDepartmentId) {
            this.props.onGetDepartmentEmployees(this.props.selectedDepartmentId)
        }
        if (!isForMobile && prevProps.searchMatch !== this.props.searchMatch) this.filterEmployees(this.props.searchMatch)
    }

    selectEmployee(el) {
        this.setState(state => {
            return {...state, selectedEmployee: el, modalShow: true}
        })
    }

    sortEmployeesForFIOAndChief(employees) {
        return employees.slice().sort((a, b) => {
            if (a.chief && !b.chief) {
                return -1;
            } else if (!a.chief && b.chief) {
                return 1;
            } else {
                const AFIO = `${a.lastName} ${a.firstName} ${a.middleName || ''}`.toLowerCase();
                const BFIO = `${b.lastName} ${b.firstName} ${b.middleName || ''}`.toLowerCase();
                return AFIO.localeCompare(BFIO);
            }
        });
    }

    filterEmployees(value = null) {
        let searchValue
        if (value !== null) searchValue = checkCyrillicLetters(value.trim())
        else searchValue = ""
        let tmp = this.sortEmployeesForFIOAndChief(this.props.departmentEmployees);
        if (searchValue !== '') {
            tmp.sort((a, b) => {
                let isALastNameCompleteMatch = a.lastName.toLowerCase() === searchValue.toLowerCase()
                let isBLastNameCompleteMatch = b.lastName.toLowerCase() === searchValue.toLowerCase()

                let completeMatch
                if (isALastNameCompleteMatch) completeMatch = -1
                else if (isBLastNameCompleteMatch) completeMatch = 1

                let fioA = a.lastName.toLowerCase() + ' ' + a.firstName.toLowerCase() + (a.middleName ? ' ' + a.middleName.toLowerCase() : '')
                let includeSorting = fioA.includes(searchValue.toLowerCase()) ? -1 : 1
                return isALastNameCompleteMatch || isBLastNameCompleteMatch ? completeMatch : includeSorting
            })
        }
        this.setState(state => {
            return {...state, employees: [...tmp], searchEmployee: searchValue}
        })
    }

    clearSearchEmployee = () => {
        this.setState(state => {
            return {...state, searchEmployee: ''}
        })
        this.filterEmployees()
    }

    setCountDepartmentEmployee = (countDepartmentEmployee) => {
        let employeeStr
        if (countDepartmentEmployee % 100 >= 11 && countDepartmentEmployee % 100 <= 19) employeeStr = ' сотрудников'
        else if (countDepartmentEmployee % 10 === 1) employeeStr = ' сотрудник'
        else if (countDepartmentEmployee % 10 >= 2 && countDepartmentEmployee % 10 <= 4) employeeStr = ' сотрудника'
        else employeeStr = ' сотрудников'
        return countDepartmentEmployee + employeeStr
    }

    setListContainer = () => {
        return <div>
            {(this.props.loadingDepartmentEmployees) ? <Spinner />
                : <div>
                    <div className={classes.departmentContainer}>
                        <div className={classes.departmentTitle}
                            onClick={() => isForMobile ? this.props.setIdForScroll(this.props.selectedDepartmentId) : null}>
                            <FontAwesomeIcon icon={faLongArrowAltLeft} size="sm"/>
                            <div className={classes.departmentName}>
                                <span>{this.props.departmentName}</span>
                            </div>
                        </div>
                        <div className={classes.countDepartmentEmployee}>{this.setCountDepartmentEmployee(this.props.departmentEmployees.length)}</div>
                    </div>
                    <div className={classes.inputContainer}>
                        <input type="text" value={this.state.searchEmployee} placeholder="Поиск..."
                            onChange={(e) => this.filterEmployees(e.target.value)}/>
                        {(this.state.searchEmployee)
                            ? <ClearButton className={classes.buttonClear}
                                onClick={() => this.clearSearchEmployee()}/> : null}
                        <FontAwesomeIcon icon={faSearch} size="lg"/>
                    </div>
                    <div className={classes.list} style={{overflowY: 'auto'}}>
                        {this.state.employees.map((el) =>
                            <EmployeesTableListItem key={el.id}
                                data={el}
                                searchEmployee={this.state.searchEmployee}
                                clicked={() => {
                                    this.selectEmployee(el)
                                }}/>
                        )}
                    </div>
                </div>}
        </div>
    }

    render() {
        return (
            <div className={classes.container}>
                {isForMobile
                    ? this.setListContainer()
                    : <Affix offsetTop={50}>
                        {this.setListContainer()}
                    </Affix>}
                {(this.state.modalShow)
                    && <CustomModal show={this.state.modalShow}
                        onHide={() => this.setState(state => {
                            return {...state, modalShow: false}
                        })}>
                        <LuExpand title={"Перейти на страницу сотрудника"}
                            className={classes.luExpand}
                            onClick={() => window.location.href = 'https://iis.bsuir.by/employees/' + this.state.selectedEmployee.urlId}
                        />

                        <EmployeePersonCard urlId={this.state.selectedEmployee.urlId}
                            key={this.state.selectedEmployee.urlId} ifModal={true}
                            closeClicked={() => this.setState(state => {
                                return {...state, modalShow: false}
                            })}/>
                    </CustomModal>}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        departmentName: state.employees.departmentName,
        departmentEmployees: state.employees.departmentEmployees,
        loadingDepartmentEmployees: state.employees.loadingDepartmentEmployees
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetDepartmentEmployees: (id) => dispatch(actions.getDepartmentEmployees(id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesTable);
